import { Resource as o, API as g } from "@coveo/platform-client";
const l = ({ language: u, country: t, currency: r }) => `${u}-${t}-${r}`, e = class e extends o {
  /**
   * List all trackingIdCatalogMappings
   * @param params TrackingIdLocalesOptions
   * @returns Promise<TrackingIdLocalesListResponse>
   */
  async list(t) {
    const r = await this.api.get(
      this.buildPath(`${e.baseUrl}`, t)
    );
    return r.items = (r.items ?? []).reduce((a, i) => {
      const s = a.find((n) => n.trackingId === i.trackingId);
      return s ? s.trackingIdToCatalogMapping = s.trackingIdToCatalogMapping.concat(
        i.trackingIdToCatalogMapping
      ) : a.push(i), a;
    }, []).reduce((a, i) => (i.trackingIdToCatalogMapping.sort((s, n) => s.primary ? -1 : n.primary || l(s) > l(n) ? 1 : -1), a.push(i), a), []), r;
  }
  /**
   * Create the mapping(s) for a tracking ID
   * @param body TrackingIdCatalogCreateBody
   * @returns Promise<TrackingIdLocalesModel>
   */
  create(t) {
    return this.api.post(e.baseUrl, t);
  }
  /**
   * Update the mapping(s) for a tracking ID
   * @param body TrackingIdCatalogUpdateBody
   * @returns Promise<TrackingIdLocalesModel>
   */
  update(t) {
    return this.api.put(e.baseUrl, t);
  }
  /**
   * Delete the mapping(s) for a tracking ID
   * @param trackingId: string
   * @returns Promise<void>
   */
  delete(t) {
    return this.api.delete(this.buildPath(`${e.baseUrl}`, { trackingId: t }));
  }
  // Flat API
  /**
   * Updates a tracking ID to catalog mapping.
   *
   * @param {string} mappingId Unique identifier of the catalog mapping.
   * @param {TrackingIdToCatalogMappingFlatBody} body New properties to apply to the mapping.
   * @returns {Promise<TrackingIdToCatalogMappingFlatModel>} The updated tracking id to catalog mapping.
   */
  flatUpdate(t, r) {
    return this.api.put(
      `${e.baseUrl}/flat/${t}`,
      r
    );
  }
  /**
   * Deletes a tracking ID to catalog mapping.
   *
   * @param {string} mappingId Unique identifier of the mapping.
   * @returns {Promise<void>}
   */
  flatDelete(t) {
    return this.api.delete(this.buildPath(`${e.baseUrl}/flat/${t}`));
  }
  /**
   * Creates a tracking ID to catalog mapping.
   *
   * @param {TrackingIdToCatalogMappingFlatBody} body
   * @returns {Promise<TrackingIdToCatalogMappingFlatModel>} The created tracking id to catalog mapping.
   */
  flatCreate(t) {
    return this.api.post(`${e.baseUrl}/flat`, t);
  }
  /**
   * Gets flattened tracking ID to catalog mappings by project.
   *
   * @param {TrackingIdLocalesFlatByProjectOptions} options Options to filter the list of returned mappings.
   * @returns {Promise<TrackingIdLocalesFlatListByProjectResponse>} The retrieved tracking id to catalog mappings and optionally associated projects.
   */
  flatListByProject(t) {
    return this.api.post(
      `${e.baseUrl}/flat/list`,
      t
    );
  }
};
e.baseUrl = `/rest/organizations/${g.orgPlaceholder}/trackingidcatalogmappings`;
let p = e;
export {
  p as TrackingIdLocales
};
//# sourceMappingURL=TrackingIdLocales.js.map
